import { render, staticRenderFns } from "./replays.vue?vue&type=template&id=42bfb866"
import script from "./replays.vue?vue&type=script&lang=js"
export * from "./replays.vue?vue&type=script&lang=js"
import style0 from "./replays.vue?vue&type=style&index=0&id=42bfb866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports